var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "link_container",
        class: { space_container_links: !_vm.isSection },
      },
      [
        _c(
          "jade-link",
          {
            attrs: {
              href: _vm.$sanitize(_vm.entity.logs_url.seq),
              rel: "noopener noreferrer",
              target: "_blank",
              variant: "brand",
              external: "",
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("log-links.seq")) + " ")]
        ),
        _c(
          "jade-link",
          {
            attrs: {
              href: _vm.$sanitize(_vm.entity.logs_url.splunk),
              rel: "noopener noreferrer",
              target: "_blank",
              variant: "brand",
              external: "",
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("log-links.splunk")) + " ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }